import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import compose from 'lodash/flowRight';
import partialRight from 'lodash/partialRight';

import OAuthCache from './oauth-strategy-cache';
import { createSSOUrl } from './oauth-strategy-utils';
import { requestRedirectToSSO } from './oauth-strategy.state';

import { getIntegrationSubtitle } from '../../integrations-utils';
import { IntegrationSlot } from '../../integrations-list/integration-slot';
import { OAuthStrategyOptions } from './oauth-strategy.types';
import { createFeatureToggleStrategyIntegration } from '../../feature-toggle-strategy-integration';

type ComponentProps = {
    redirectToSSO: (url: string) => void
    isIntegrated: boolean
}
export const createOAuthIntegration = (providerOptions: OAuthStrategyOptions) => {
    const {
        title,
        id,
        issuerUrl = '',
        responseType = 'code',
        icon = null,
        scopes = [''],
        clientId,
        testId = 'default-integration',
        dataAppcuesId,
        Component,
    } = providerOptions;

    OAuthCache.register(providerOptions);

    const SSODefaultProps = {
        clientId,
        scopes,
        responseType,
        providerId: id,
    };

    const ComponentImpl = ({ redirectToSSO, isIntegrated, ...props }: ComponentProps) => {
        const [defaultUrl] = useState(
            createSSOUrl(issuerUrl, SSODefaultProps),
        );

        const SlotComponent = Component || IntegrationSlot;

        return (
            <SlotComponent
                dataAppcuesId={dataAppcuesId}
                title={title}
                isDisabled={false}
                icon={icon}
                testId={testId}
                doIntegration={
                    compose(
                        redirectToSSO,
                        partialRight(createSSOUrl, SSODefaultProps),
                    )
                }
                defaultUrl={defaultUrl}
                isIntegrated={isIntegrated}
                onClick={() => redirectToSSO(defaultUrl)}
                subtitle={getIntegrationSubtitle({ isDisabled: false, isIntegrated })}
                {...props}
            />
        );
    };

    const OAuthComponent = connect(
        null,
        dispatch => bindActionCreators({
            redirectToSSO: requestRedirectToSSO,
        }, dispatch),
    )(ComponentImpl);

    return {
        id,
        Component: OAuthComponent,
    };
};

export const createFeatureToggleOAuthIntegration = (
    props: OAuthStrategyOptions,
) => createFeatureToggleStrategyIntegration(props, createOAuthIntegration);
